const e = {
  none: "0",
  hairline: "0.03125rem",
  thin: "0.0625rem",
  thick: "0.125rem",
  heavy: "0.25rem"
}, a = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  pill: "62.5rem",
  circular: "50%"
}, t = {
  "black-100": "#606b85",
  "black-200": "#5c657a",
  "black-300": "#515b71",
  "black-400": "#4b5367",
  "black-500": "#424a5c",
  "black-600": "#3f4450",
  "black-700": "#383b42",
  "black-800": "#232529",
  "black-850": "#1A1A1A",
  "black-900": "#000000",
  "blue-100": "#e7f5fc",
  "blue-200": "#b8e0f6",
  "blue-300": "#88ccf1",
  "blue-400": "#70c2ee",
  "blue-500": "#41ade8",
  "blue-600": "#1A96DA",
  "blue-700": "#126999",
  "blue-800": "#0d4b6d",
  "blue-900": "#051e2c",
  "gradient-rainbow-horizontal": "linear-gradient(90deg, #a51cf1 0%, #336dff 10%, #31bbfd 20%, #36d3e6 30%, #1decbb 40%, #b9eb4d 50%, #ffda19 60%, #ff781d 70%, #ff2055 80%, #e40aaf 90%, #a51cf1 100%)",
  "gradient-pink": "linear-gradient(134deg, #ce55b0 0%, #f34dac 40.62%, #f48e66 87.06%)",
  "gradient-green": "linear-gradient(134deg, #b2ce37 0%, #63d7af 91.96%)",
  "gradient-blue": "linear-gradient(135deg, #63d7af 0%, #1cc2df 50%, #0580e6 100%)",
  "gradient-purple": "linear-gradient(132deg, #0580e6 0%, #f34dac 98.73%)",
  "green-100": "#f2faeb",
  "green-200": "#d7f0c2",
  "green-300": "#bce699",
  "green-400": "#afe085",
  "green-500": "#94d65c",
  "green-600": "#79CC33",
  "green-700": "#558f24",
  "green-800": "#3d6619",
  "green-900": "#18290a",
  "peach-100": "#ffeee8",
  "peach-200": "#ffceba",
  "peach-300": "#ffac8d",
  "peach-400": "#ff9c76",
  "peach-500": "#ff7b48",
  "peach-600": "#FF5A1A",
  "peach-700": "#c53700",
  "peach-800": "#8d2700",
  "peach-900": "#381000",
  "pink-100": "#fde7f4",
  "pink-200": "#fab7de",
  "pink-300": "#f788c8",
  "pink-400": "#f570bc",
  "pink-500": "#f240a6",
  "pink-600": "#EF1090",
  "pink-700": "#a70b65",
  "pink-800": "#780848",
  "pink-900": "#30031d",
  "purple-100": "#efecfb",
  "purple-200": "#d0c5f2",
  "purple-300": "#b19fe9",
  "purple-400": "#a18ce5",
  "purple-500": "#8265dc",
  "purple-600": "#633fd3",
  "purple-700": "#41249c",
  "purple-800": "#2e1a6f",
  "purple-900": "#130a2d",
  "teal-100": "#eafaf4",
  "teal-200": "#c1efdf",
  "teal-300": "#98e4ca",
  "teal-400": "#83dfbf",
  "teal-500": "#59d5aa",
  "teal-600": "#33C794",
  "teal-700": "#248b68",
  "teal-800": "#1a644a",
  "teal-900": "#0a281e",
  "white-100": "#ffffff",
  "white-200": "#f5f6fa",
  "white-300": "#ebeef5",
  "white-400": "#d3dae8",
  "white-500": "#c0c7d8",
  "white-600": "#b2bacc",
  "white-700": "#a6aebf",
  "white-800": "#a6aebf",
  "white-900": "#8d94a5",
  "yellow-100": "#fff8e6",
  "yellow-200": "#fee9b5",
  "yellow-300": "#feda84",
  "yellow-400": "#fdd26b",
  "yellow-500": "#fdc339",
  "yellow-600": "#FCB408",
  "yellow-700": "#b47f02",
  "yellow-800": "#805b02",
  "yellow-900": "#332401"
}, r = {
  quarck: "0.25rem",
  nano: "0.5rem",
  xxxs: "0.75rem",
  xxs: "1rem",
  xs: "1.25rem",
  s: "1.5rem",
  sm: "2rem",
  md: "2.5rem",
  lg: "3rem",
  xl: "3.5rem",
  xxl: "4rem",
  xxxl: "5rem",
  huge: "7.5rem",
  giant: "10rem"
}, c = {
  "background-default": "#ffffff",
  "background-default-dark": "#000000",
  "background-contrast": "#f5f6fa",
  "background-contrast-dark": "#1a1a1a",
  "background-hover": "rgba(0, 0, 0, 0.06)",
  "background-hover-dark": "rgba(255, 255, 255, 0.15)",
  "background-selected": "rgba(0, 0, 0, 0.1)",
  "background-selected-dark": "rgba(255, 255, 255, 0.25)",
  "background-overlay": "#ffffff",
  "background-overlay-dark": "#1a1a1a",
  "background-primary": "#efecfb",
  "background-primary-dark": "#160c34",
  "background-critical": "#faece8",
  "background-critical-dark": "#2c120a",
  "background-warning": "#fdf5eb",
  "background-warning-dark": "#332107",
  "background-success": "#ebf6ef",
  "background-success-dark": "#0e1f14",
  "background-highlighted-primary": "#633fd3",
  "background-highlighted-primary-dark": "#8265dc",
  "background-highlighted-success": "#459B64",
  "background-highlighted-success-dark": "#459B64",
  "background-highlighted-warning": "#E6A03B",
  "background-highlighted-warning-dark": "#E6A03B",
  "background-highlighted-critical": "#BC4D29",
  "background-highlighted-critical-dark": "#D4613A",
  "background-level0": "#f5f6fa",
  "background-level0-dark": "#000000",
  "background-level1": "#ffffff",
  "background-level1-dark": "#1A1A1A",
  "border-default": "#e8e8e8",
  "border-default-dark": "#333333",
  "border-form": "#707070",
  "border-form-dark": "#858585",
  "border-form-critical": "#BC4D29",
  "border-form-critical-dark": "#D4613A",
  "border-contrast": "#d7dbeb",
  "border-contrast-dark": "#484848",
  "border-selected": "#000000",
  "border-selected-dark": "#ffffff",
  "border-primary": "#d1c8f3",
  "border-primary-dark": "#351d7c",
  "border-critical": "#f2cfc4",
  "border-critical-dark": "#76301b",
  "border-warning": "#f9e1c3",
  "border-warning-dark": "#825412",
  "border-success": "#cde9d7",
  "border-success-dark": "#2b5f3d",
  "border-accessible-border": "#707070",
  "border-accessible-border-dark": "#858585",
  "content-default": "#000000",
  "content-default-dark": "#ffffff",
  "content-subdued": "#707070",
  "content-subdued-dark": "#858585",
  "content-disabled": "#6B6B6B",
  "content-disabled-dark": "#8C8C8C",
  "content-placeholder": "#707070",
  "content-placeholder-dark": "#858585",
  "content-primary": "#633fd3",
  "content-primary-dark": "#8265dc",
  "content-success": "#459B64",
  "content-success-dark": "#459B64",
  "content-warning": "#E6A03B",
  "content-warning-dark": "#E6A03B",
  "content-critical": "#BC4D29",
  "content-critical-dark": "#D4613A",
  "content-accent-success": "#3E7957",
  "content-accent-success-dark": "#459B64",
  "content-accent-warning": "#A45E0A",
  "content-accent-warning-dark": "#E6A03B",
  "content-accent-critical": "#B64C2F",
  "content-accent-critical-dark": "#D4613A",
  "content-above-primary": "#ffffff",
  "content-above-primary-dark": "#000000",
  "content-above-secondary": "#000000",
  "content-above-secondary-dark": "#ffffff",
  "content-above-text": "#000000",
  "content-above-text-dark": "#ffffff",
  "content-above-contrast": "#000000",
  "content-above-contrast-dark": "#ffffff",
  "content-above-critical": "#BC4D29",
  "content-above-critical-dark": "#D4613A",
  "interactive-primary-default": "#000000",
  "interactive-primary-default-dark": "#ffffff",
  "interactive-primary-hover": "#0d0d0d",
  "interactive-primary-hover-dark": "#f2f2f2",
  "interactive-primary-pressed": "#242424",
  "interactive-primary-pressed-dark": "#dbdbdb",
  "interactive-secondary-default": "#ebebeb",
  "interactive-secondary-default-dark": "#2e2e2e",
  "interactive-secondary-hover": "#dedede",
  "interactive-secondary-hover-dark": "#212121",
  "interactive-secondary-pressed": "#c7c7c7",
  "interactive-secondary-pressed-dark": "#0a0a0a",
  "interactive-contrast-default": "#ffffff",
  "interactive-contrast-default-dark": "#4b5367",
  "interactive-contrast-hover": "rgba(255, 255, 255, 0.9)",
  "interactive-contrast-hover-dark": "rgba(75, 83, 103, 0.9)",
  "interactive-contrast-pressed": "rgba(255, 255, 255, 0.75)",
  "interactive-contrast-pressed-dark": "rgba(75, 83, 103, 0.75)",
  "interactive-text-default": "rgba(0, 0, 0, 0)",
  "interactive-text-default-dark": "rgba(255, 255, 255, 0)",
  "interactive-text-hover": "rgba(0, 0, 0, 0.1)",
  "interactive-text-hover-dark": "rgba(255, 255, 255, 0.1)",
  "interactive-text-pressed": "rgba(0, 0, 0, 0.12)",
  "interactive-text-pressed-dark": "rgba(255, 255, 255, 0.12)",
  "interactive-critical-default": "#faece8",
  "interactive-critical-default-dark": "#2c120a",
  "interactive-critical-hover": "#f6dcd4",
  "interactive-critical-hover-dark": "#3f1a0e",
  "interactive-critical-pressed": "#eebeb1",
  "interactive-critical-pressed-dark": "#602716",
  "interactive-disabled": "#ebeef5",
  "interactive-disabled-dark": "#232529",
  "benefits-meal-voucher-content-default": "#EF1090",
  "benefits-meal-voucher-content-default-dark": "#EF1090",
  "benefits-meal-voucher-content-selected": "#a70b65",
  "benefits-meal-voucher-content-selected-dark": "#f458b1",
  "benefits-meal-voucher-background-default": "#fde7f4",
  "benefits-meal-voucher-background-default-dark": "#30031d",
  "benefits-meal-voucher-background-selected": "#f7a4d5",
  "benefits-meal-voucher-background-selected-dark": "#710744",
  "benefits-gift-content-default": "#F35728",
  "benefits-gift-content-default-dark": "#F35728",
  "benefits-gift-content-selected": "#bc330a",
  "benefits-gift-content-selected-dark": "#f78969",
  "benefits-gift-background-default": "#feeeea",
  "benefits-gift-background-default-dark": "#360f03",
  "benefits-gift-background-selected": "#fbb5a4",
  "benefits-gift-background-selected-dark": "#762107",
  "benefits-mobility-content-default": "#48A202",
  "benefits-mobility-content-default-dark": "#48A202",
  "benefits-mobility-content-selected": "#327101",
  "benefits-mobility-content-selected-dark": "#77fc10",
  "benefits-mobility-background-default": "#ecffdd",
  "benefits-mobility-background-default-dark": "#0e2000",
  "benefits-mobility-background-selected": "#c4ff96",
  "benefits-mobility-background-selected-dark": "#2d6800",
  "benefits-personal-wallet-content-default": "#0392E5",
  "benefits-personal-wallet-content-default-dark": "#0392E5",
  "benefits-personal-wallet-content-selected": "#0266a0",
  "benefits-personal-wallet-content-selected-dark": "#3fb7fc",
  "benefits-personal-wallet-background-default": "#e4f5ff",
  "benefits-personal-wallet-background-default-dark": "#011d2e",
  "benefits-personal-wallet-background-selected": "#9cdaff",
  "benefits-personal-wallet-background-selected-dark": "#024872",
  "benefits-cashback-content-default": "#CA7628",
  "benefits-cashback-content-default-dark": "#CA7628",
  "benefits-cashback-content-selected": "#8d531c",
  "benefits-cashback-content-selected-dark": "#e09f62",
  "benefits-cashback-background-default": "#fbf1e9",
  "benefits-cashback-background-default-dark": "#281808",
  "benefits-cashback-background-selected": "#f0caac",
  "benefits-cashback-background-selected-dark": "#623b14",
  "social-pot-content-default": "#0392E5",
  "social-pot-content-default-dark": "#0392E5",
  "social-pot-content-selected": "#0266a0",
  "social-pot-content-selected-dark": "#3fb7fc",
  "social-pot-background-default": "#e4f5ff",
  "social-pot-background-default-dark": "#011d2e",
  "social-pot-background-selected": "#9cdaff",
  "social-pot-background-selected-dark": "#024872",
  "social-activity-content-default": "#48A202",
  "social-activity-content-default-dark": "#48A202",
  "social-activity-content-selected": "#327101",
  "social-activity-content-selected-dark": "#77fc10",
  "social-activity-background-default": "#ecffdd",
  "social-activity-background-default-dark": "#0e2000",
  "social-activity-background-selected": "#c4ff96",
  "social-activity-background-selected-dark": "#2d6800",
  "social-pulse-content-default": "#1CA07B",
  "social-pulse-content-default-dark": "#1CA07B",
  "social-pulse-content-selected": "#147056",
  "social-pulse-content-selected-dark": "#3fddb1",
  "social-pulse-background-default": "#e4faf4",
  "social-pulse-background-default-dark": "#062019",
  "social-pulse-background-selected": "#a8efdb",
  "social-pulse-background-selected-dark": "#115c48",
  "social-praise-default-content-default": "#EF1090",
  "social-praise-default-content-default-dark": "#EF1090",
  "social-praise-default-content-selected": "#a70b65",
  "social-praise-default-content-selected-dark": "#f458b1",
  "social-praise-default-background-default": "#fde7f4",
  "social-praise-default-background-default-dark": "#30031d",
  "social-praise-default-background-selected": "#f7a4d5",
  "social-praise-default-background-selected-dark": "#710744",
  "social-praise-birthday-content-default": "#633fd3",
  "social-praise-birthday-content-default-dark": "#8265dc",
  "social-praise-birthday-content-selected": "#41249c",
  "social-praise-birthday-content-selected-dark": "#a893e7",
  "social-praise-birthday-background-default": "#efecfb",
  "social-praise-birthday-background-default-dark": "#160c34",
  "social-praise-birthday-background-selected": "#bcb0ee",
  "social-praise-birthday-background-selected-dark": "#2d196a",
  "social-praise-celebration-content-default": "#EF1090",
  "social-praise-celebration-content-default-dark": "#EF1090",
  "social-praise-celebration-content-selected": "#a70b65",
  "social-praise-celebration-content-selected-dark": "#f458b1",
  "social-praise-celebration-background-default": "#fde7f4",
  "social-praise-celebration-background-default-dark": "#30031d",
  "social-praise-celebration-background-selected": "#f7a4d5",
  "social-praise-celebration-background-selected-dark": "#710744",
  "social-praise-congrats-content-default": "#48A202",
  "social-praise-congrats-content-default-dark": "#48A202",
  "social-praise-congrats-content-selected": "#327101",
  "social-praise-congrats-content-selected-dark": "#77fc10",
  "social-praise-congrats-background-default": "#ecffdd",
  "social-praise-congrats-background-default-dark": "#0e2000",
  "social-praise-congrats-background-selected": "#c4ff96",
  "social-praise-congrats-background-selected-dark": "#2d6800",
  "social-praise-egoboost-content-default": "#0392E5",
  "social-praise-egoboost-content-default-dark": "#0392E5",
  "social-praise-egoboost-content-selected": "#0266a0",
  "social-praise-egoboost-content-selected-dark": "#3fb7fc",
  "social-praise-egoboost-background-default": "#e4f5ff",
  "social-praise-egoboost-background-default-dark": "#011d2e",
  "social-praise-egoboost-background-selected": "#9cdaff",
  "social-praise-egoboost-background-selected-dark": "#024872",
  "social-praise-onboarding-content-default": "#CA7628",
  "social-praise-onboarding-content-default-dark": "#CA7628",
  "social-praise-onboarding-content-selected": "#8d531c",
  "social-praise-onboarding-content-selected-dark": "#e09f62",
  "social-praise-onboarding-background-default": "#fbf1e9",
  "social-praise-onboarding-background-default-dark": "#281808",
  "social-praise-onboarding-background-selected": "#f0caac",
  "social-praise-onboarding-background-selected-dark": "#623b14",
  "social-praise-proanniversary-content-default": "#F35728",
  "social-praise-proanniversary-content-default-dark": "#F35728",
  "social-praise-proanniversary-content-selected": "#bc330a",
  "social-praise-proanniversary-content-selected-dark": "#f78969",
  "social-praise-proanniversary-background-default": "#feeeea",
  "social-praise-proanniversary-background-default-dark": "#360f03",
  "social-praise-proanniversary-background-selected": "#fbb5a4",
  "social-praise-proanniversary-background-selected-dark": "#762107",
  "social-praise-procelebration-content-default": "#F35728",
  "social-praise-procelebration-content-default-dark": "#F35728",
  "social-praise-procelebration-content-selected": "#bc330a",
  "social-praise-procelebration-content-selected-dark": "#f78969",
  "social-praise-procelebration-background-default": "#feeeea",
  "social-praise-procelebration-background-default-dark": "#360f03",
  "social-praise-procelebration-background-selected": "#fbb5a4",
  "social-praise-procelebration-background-selected-dark": "#762107",
  "social-praise-thanks-content-default": "#EF1090",
  "social-praise-thanks-content-default-dark": "#EF1090",
  "social-praise-thanks-content-selected": "#a70b65",
  "social-praise-thanks-content-selected-dark": "#f458b1",
  "social-praise-thanks-background-default": "#fde7f4",
  "social-praise-thanks-background-default-dark": "#30031d",
  "social-praise-thanks-background-selected": "#f7a4d5",
  "social-praise-thanks-background-selected-dark": "#710744",
  "social-article-content-default": "#CA7628",
  "social-article-content-default-dark": "#CA7628",
  "social-article-content-selected": "#8d531c",
  "social-article-content-selected-dark": "#e09f62",
  "social-article-background-default": "#fbf1e9",
  "social-article-background-default-dark": "#281808",
  "social-article-background-selected": "#f0caac",
  "social-article-background-selected-dark": "#623b14",
  "cards-black-primary": "#111111",
  "cards-black-primary-dark": "#111111",
  "cards-black-accent": "#272727",
  "cards-black-accent-dark": "#272727",
  "cards-grey-primary": "#585858",
  "cards-grey-primary-dark": "#585858",
  "cards-grey-accent": "#e5e5e5",
  "cards-grey-accent-dark": "#e5e5e5",
  "cards-midnight-blue-primary": "#00084b",
  "cards-midnight-blue-primary-dark": "#00084b",
  "cards-midnight-blue-accent": "#e5e8ff",
  "cards-midnight-blue-accent-dark": "#e5e8ff",
  "cards-gold-primary": "#c8ba95",
  "cards-gold-primary-dark": "#c8ba95",
  "cards-gold-accent": "#f3f0e7",
  "cards-gold-accent-dark": "#f3f0e7",
  "cards-pink-primary": "#edc2bd",
  "cards-pink-primary-dark": "#edc2bd",
  "cards-pink-accent": "#f7e5e3",
  "cards-pink-accent-dark": "#f7e5e3",
  "title-red": "#FF2055",
  "title-red-dark": "#FF2055",
  "title-blue": "#336DFF",
  "title-blue-dark": "#336DFF",
  "title-magenta": "#E40AAF",
  "title-magenta-dark": "#E40AAF",
  "title-indigo": "#A51CF1",
  "title-indigo-dark": "#A51CF1",
  "travel-hotel-purple-base": "#631191",
  "travel-hotel-purple-base-dark": "#631191",
  "travel-hotel-purple-light": "#C060F5",
  "travel-hotel-purple-light-dark": "#C060F5",
  "travel-hotel-pink-base": "#FFA6BB",
  "travel-hotel-pink-base-dark": "#FFA6BB",
  "travel-hotel-pink-light": "#FFD2DD",
  "travel-hotel-pink-light-dark": "#FFD2DD",
  "travel-rental-red-base": "#991333",
  "travel-rental-red-base-dark": "#991333",
  "travel-rental-red-light": "#FF6388",
  "travel-rental-red-light-dark": "#FF6388",
  "travel-rental-orange-base": "#FFD1B3",
  "travel-rental-orange-base-dark": "#FFD1B3",
  "travel-rental-orange-light": "#FFE8D9",
  "travel-rental-orange-light-dark": "#FFE8D9",
  "travel-train-green-base": "#008C6B",
  "travel-train-green-base-dark": "#008C6B",
  "travel-train-green-light": "#4CF0C9",
  "travel-train-green-light-dark": "#4CF0C9",
  "travel-train-lime-base": "#DFF6AF",
  "travel-train-lime-base-dark": "#DFF6AF",
  "travel-train-lime-light": "#EFFAD7",
  "travel-train-lime-light-dark": "#EFFAD7",
  "travel-plane-blue-base": "#1F4199",
  "travel-plane-blue-base-dark": "#1F4199",
  "travel-plane-blue-light": "#6FCFFE",
  "travel-plane-blue-light-dark": "#6FCFFE",
  "travel-plane-mint-base": "#99F7E0",
  "travel-plane-mint-base-dark": "#99F7E0",
  "travel-plane-mint-light": "#CCFBF0",
  "travel-plane-mint-light-dark": "#CCFBF0"
};
export {
  a as BORDER_RADIUS,
  e as BORDER_WIDTH,
  t as COLORS,
  r as SPACING,
  c as theme
};
